<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="900" scrollable>
			<v-card>
				<v-card-title class="text-h6">
					<span>Detail Sales Order</span>
					<span class="pl-2 font-weight-bold">{{detailSO.so_code}}</span>
				</v-card-title>
				<v-card-text class="black--text">
					<v-row class="mb-3">
						<v-col cols="6" md="6">
							<div class="text-subtitle-1 font-weight-bold">Detail Mitra</div>
							<div class="pt-1">{{detailSO.customer_network_code}} ({{detailSO.customer_name}})</div>
							<div class="pt-1">{{detailSO.customer_mobilephone}}</div>
							<div class="pt-1">{{addressText(detailSO)}}</div>
							<div class="text-subtitle-1 font-weight-bold">Detail Pembayaran</div>
							<div class="pt-1" v-html="detailSO.so_payment_note_full ? detailSO.so_payment_note_full : '-'"></div>
							<div class="pt-1" v-html="detailSO.so_payment_type == 'va_bca' ? 'No VA : ' + detailSO.so_payment_data.va_number : ''"></div>
							<div class="pt-1" v-if="detailSO.so_customer_bank != null">
								{{ detailSO.so_customer_bank.customer_bank_name }} {{ detailSO.so_customer_bank.customer_bank_customer_number }} a/n {{ detailSO.so_customer_bank.customer_bank_customer_name }}
							</div>
						</v-col>
						<v-col cols="6" md="6">
							<div class="text-subtitle-1 font-weight-bold">Status Sales Order</div>
							<v-col cols="8" class="mt-1 pa-0">
								<div class="primary rounded text-subtitle-2 font-weight-bold text-uppercase white--text text-center font-weight-bold pa-2 d-flex justify-center">
									{{detailSO.so_status | toStatusSOWH}}
								</div>
							</v-col>
							<div class="text-subtitle-1 mt-3 font-weight-bold">Catatan</div>
							<v-col cols="12" class="pa-0">
								<div class="pt-1">{{detailSO.so_note ? detailSO.so_note : '-'}}</div>
							</v-col>
						</v-col>
					</v-row>
					<v-list color="deep-purple lighten-5" class="pa-1 mb-3" rounded>
						<v-list-item dense class="px-1 justify-center">
							<div class="font-weight-bold text-uppercase primary--text">detail produk</div>
						</v-list-item>
					</v-list>
					<v-card class="mb-5 elevation-0">
						<v-data-table :headers="headers" :items="detailSO.so_detail" hide-default-footer>
							<template v-slot:item.so_detail_quantity_sold="{ item }">
								<div>{{ item.so_detail_quantity_sold  | toNumber }} {{item.so_detail_product_unit}}</div>
							</template>
							<template v-slot:item.so_detail_quantity_received="{ item }">
								<div>{{ item.so_detail_quantity_received  | toNumber }} {{item.so_detail_product_unit}}</div>
							</template>
							<template v-slot:item.so_detail_quantity_transport="{ item }">
								<div>{{ item.so_detail_quantity_transport  | toNumber }} {{item.so_detail_product_unit}}</div>
							</template>
							<template v-slot:item.so_detail_product_price="{ item }">
								<div>{{ item.so_detail_product_price | toNumber }}</div>
							</template>
							<template v-slot:item.total_price="{ item }">
								<div>{{ item.so_detail_product_price * item.so_detail_quantity_sold  | toNumber }}</div>
							</template>
							<template v-slot:footer>
								<v-row class="mt-n3">
									<v-col offset="8">Subtotal</v-col>
									<v-col class="font-weight-bold text-right">{{ grandTotal | toRupiah }}</v-col>
								</v-row>
								<v-row class="mt-n3" v-if="discountTotal > 0">
									<v-col offset="8">Diskon</v-col>
									<v-col class="font-weight-bold text-right">{{ discountTotal | toRupiah }}</v-col>
								</v-row>
								<v-row class="mt-n3">
									<v-col offset="8">Total Harga</v-col>
									<v-col class="font-weight-bold text-right">{{ grandTotal - discountTotal | toRupiah }}</v-col>
								</v-row>
								<v-row class="mt-n3">
									<v-col offset="8">Potongan Harga</v-col>
									<v-col class="font-weight-bold text-right">{{ detailSO.so_rebate_value | toRupiah }}</v-col>
								</v-row>
								<v-row class="mt-n3" v-if="materai > 0">
									<v-col offset="8">Materai</v-col>
									<v-col class="font-weight-bold text-right">{{ materai | toRupiah }}</v-col>
								</v-row>
								<v-row class="mt-n3">
									<v-col offset="8">Total Bayar</v-col>
									<v-col class="font-weight-bold text-right">{{ (grandTotal - discountTotal - detailSO.so_rebate_value + materai) | toRupiah }}</v-col>
								</v-row>
							</template>
						</v-data-table>
					</v-card>
					<v-list color="deep-purple lighten-5" class="pa-1 mb-3" rounded>
						<v-list-item dense class="px-1 justify-center">
							<div class="font-weight-bold text-uppercase primary--text">Status Sales Order</div>
						</v-list-item>
					</v-list>
					<v-row class="mb-3" v-if="detailSO.so_status_completed_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailSO.so_status == 'completed' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'completed' | toStatusSOWH}}</div>
						</v-col>
						<v-col cols="4" md="4" class="text-body-2">
							<div>{{detailSO.so_status_completed_user_name}}</div>
						</v-col>
						<v-col cols="4" md="4" class="text-body-2">
							<div>{{detailSO.so_status_completed_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-3" v-if="detailSO.so_status_processed_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailSO.so_status == 'processed' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'processed' | toStatusSOWH}}</div>
						</v-col>
						<v-col cols="4" md="4" class="text-body-2">
							<div>{{detailSO.so_status_processed_user_name}}</div>
						</v-col>
						<v-col cols="4" md="4" class="text-body-2">
							<div>{{detailSO.so_status_processed_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-3" v-if="detailSO.so_status_canceled_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailSO.so_status == 'canceled' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'canceled' | toStatusSOWH}}</div>
						</v-col>
						<v-col cols="4" md="4" class="text-body-2">
							<div>{{detailSO.so_status_canceled_user_name}}</div>
						</v-col>
						<v-col cols="4" md="4" class="text-body-2">
							<div>{{detailSO.so_status_canceled_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>

					<v-row class="mb-3" v-if="detailSO.so_status_approval_refund_datetime_approved">
						<v-col cols="4" md="4" class="py-0">
							<div class="rounded caption text-uppercase white--text text-right pa-3 grey">Dana Dikembalikan</div>
						</v-col>
						<v-col cols="4" md="4" class="text-body-2">
							<div>{{detailSO.so_status_approval_refund_user_name_approved}}</div>
						</v-col>
						<v-col cols="4" md="4" class="text-body-2">
							<div>{{detailSO.so_status_approval_refund_datetime_approved | haritanggaljam}}</div>
						</v-col>
					</v-row>

					<v-row class="mb-3" v-if="detailSO.so_status_approval_refund_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailSO.so_status == 'approval_refund' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'approval_refund' | toStatusSOWH}}</div>
						</v-col>
						<v-col cols="4" md="4" class="text-body-2">
							<div>{{detailSO.so_status_approval_refund_user_name}}</div>
						</v-col>
						<v-col cols="4" md="4" class="text-body-2">
							<div>{{detailSO.so_status_approval_refund_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>

					<v-row class="mb-3" v-if="detailSO.so_status_paid_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailSO.so_status == 'paid' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'paid' | toStatusSOWH}}</div>
						</v-col>
						<v-col cols="4" md="4" class="text-body-2">
							<div>{{detailSO.so_status_paid_user_name}}</div>
						</v-col>
						<v-col cols="4" md="4" class="text-body-2">
							<div>{{detailSO.so_status_paid_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-3" v-if="detailSO.so_status_created_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailSO.so_status == 'created' ? 'primary' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'created' | toStatusSOWH}}</div>
						</v-col>
						<v-col cols="4" md="4" class="text-body-2">
							<div>{{ detailSO.so_status_created_user_name}}</div>
						</v-col>
						<v-col cols="4" md="4" class="text-body-2">
							<div>{{ detailSO.so_status_created_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideDialog">Tutup</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			singleSelect: false,
			selected: [],
			headers: [
			{ text: 'Nama Produk', value: 'so_detail_product_name', sortable: false},
			{ text: 'Jumlah Dipesan', value: 'so_detail_quantity_sold', sortable: false, align: 'center' },
			{ text: 'Jumlah Diterima', value: 'so_detail_quantity_received', sortable: false, align: 'center' },
			{ text: 'Jumlah Dijalan', value: 'so_detail_quantity_transport', sortable: false, align: 'center' },
			{ text: 'Harga(Rp)', value: 'so_detail_product_price', align: 'end'},
			{ text: 'Total Harga(Rp)', value: 'total_price', align: 'end', sortable: false},
			],
			products: [
			{
				item: 'Milagros Water',
				total: 10,
				price: '300.000',
				total_price: '3.000.000',
			},
			],
			so_payment_type: []
		}
	},
	computed:{
		...mapState('so', ['detailSO']),

		grandTotal(){
			let total = 0
			if (this.detailSO.so_detail) {
				this.detailSO.so_detail.forEach( (el) => {
					total += el.so_detail_product_price * el.so_detail_quantity_sold
				});
			}
			return total
		},

		discountTotal() {
			return this.detailSO.so_discount_percent * this.grandTotal / 100
		},
		materai() {
			return parseInt(this.detailSO.so_materai_value)
		}
	},
	props: {
		dialog: Boolean
	},
	methods :{
		hideDialog(){
			this.$emit('hideDialog')
		},
		addressText(value) {
			var data = []
			if (value.customer_address)
				data.push(value.customer_address)
			if (value.customer_subdistrict_name)
				data.push(value.customer_subdistrict_name)
			if (value.customer_city_name)
				data.push(value.customer_city_name)
			if (value.customer_province_name)
				data.push(value.customer_province_name)
			return data.join(', ')
		},
		paymentType() {
			if (this.detailSO.so_payment_type) {
				this.so_payment_type = this.detailSO.so_payment_type.split(',')
			} else {
				this.so_payment_type = []
			}
		}
	}
};
</script>
